import React, { useEffect, useState, useCallback } from 'react';
import Paginate from 'react-js-pagination';
import clsx from 'clsx';
import { FaFilter } from 'react-icons/fa';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setCookie } from '@utils/cookies';
import decodeHash from '@utils/decodeHash';
import { IconChevronLeft, IconChevronRight } from '@searchComponents/icons';

import {
    paginate,
    pagination,
    item,
    link,
    activeLink,
    first
} from '../../../styles/components/pagination.module.scss';

import {
    opened,
    showFilter,
    defaultFilter,
    fixedBar,
    fixedBarBtn,
    fixedBarActive
} from '../../../styles/components/filter.module.scss';

import {
    resultsSearch,
    resultsSelection
} from '../../../styles/components/results.module.scss';

import { searchPostsAction, setFilter } from '../store/actions';
import Filters from './Filters';
import SearchResult from './SearchResult';
import SearchField from './SearchField';
import SearchSelection from './SearchSelection';
import { IconChevronsLeft, IconChevronsRight, IconFilters } from './icons';
import SearchForm from './SearchForm';
import MechanicButton from './MechanicButton';

function Content() {
    const dispatch = useDispatch();
    const history = useHistory();
    // eslint-disable-next-line no-unused-vars
    const [didLoad, setDidLoad] = useState(false);
    const data = useSelector(({ searchReducer }) => searchReducer.searchPostsData.data);
    const appSettings = useSelector(({ rootReducer }) => rootReducer.baseSettings);
    const isLoad = useSelector(({ searchReducer }) => searchReducer.isLoad);
    const filter = useSelector(({ searchReducer }) => searchReducer.hash);
    const [isShowFilter, setIsShowFilter] = useState(false);
    const [reset, setReset] = useState(false);
    const [mechanicButtonData, setMechanicButtonData] = useState(null);
    const root = document.getElementById('js-fs-search');
    const searchFields = ['search', 'recruitee_city', 'recruitee_expertise'];

    const setPage = (page) => {
        dispatch(setFilter(`page=${page}`));

        if (!isLoad) {
            setTimeout(() => {
                let element = document.getElementById('js-fs-search');
                let headerOffset = 25;
                let elementPosition = element.getBoundingClientRect().top;
                let offsetPosition = elementPosition - headerOffset;

                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });
            }, 300);
        }
    };

    const resetHandler = useCallback((isReset) => {
        setReset(isReset);
    }, []);

    useEffect(() => {

        if (reset || (filter === null && !history.location.hash)) {

            history.push({
                pathname: appSettings.searchSlug,
                hash: `#page=1&orderby=${appSettings.searchOrderby}&order=${appSettings.searchOrder}${root.dataset.searchFacetsDefault}`
            });

            setReset(false);
            setDidLoad(true);

            return dispatch(searchPostsAction({
                data: {
                    facets: appSettings.facets,
                    query_args: appSettings.query_args
                }
            }, root.dataset.searchFacetsDefault));
        }

        if (filter !== null) {
            dispatch(searchPostsAction(decodeHash(filter), history, filter));
        }
    }, [filter]);

    useEffect(() => {
        if (data?.pager?.page > data?.pager?.total_pages) {
            dispatch(setFilter(`page=${1}`));
        }
        setMechanicButtonData(data?.facets?.recruitee_mobility_type?.choices);
    }, [data]);

    useEffect(() => {
        if (history.location.hash) {
            dispatch(setFilter(history.location.hash.replace('#', '')));
        }
    }, []);

    const openFilter = useCallback(() => {
        document.body.classList.add(opened);

        setIsShowFilter(true);
    }, [setIsShowFilter]);

    const closeFilter = useCallback(() => {
        document.body.classList.remove(opened);

        setIsShowFilter(false);
    }, [setIsShowFilter]);

    setCookie("searchStateUrl", window.location.hash);

    return (
        <>
            <MechanicButton mobilityTypes={mechanicButtonData}/>
            <div className={`${resultsSearch}`}>
                {
                    data?.facets && <>
                        <SearchForm
                            fieldData={searchFields.map((field) => data.facets[field]).filter((field) => field !== undefined)}
                            openFilter={() => {
                            }}
                            onPressSearch={() => {
                            }}
                        />
                    </>
                }
            </div>
            <div
                className={clsx(`fs_facet-search--filter ${defaultFilter}`, isShowFilter && `fs_facet-search--filter-active  ${showFilter}`)}>
                <Filters params={data?.facets} closeFilter={closeFilter} resetHandler={resetHandler} />
            </div>
            {data?.facets && (
                <div className={resultsSelection}>
                    <SearchSelection params={data?.facets}
                                     data={Object.keys(data?.facets || {}).reduce((acc, cur) => (cur === 'price' ? ([...acc]) : ([...acc, ...data?.facets[cur].selected])), [])}
                                     resetHandler={resetHandler} />
                </div>
            )}
            <SearchResult data={data?.results} resetHandler={resetHandler} />
            <div className={`${paginate}`}>
                {/* eslint-disable */}
                {data?.pager && (
                    <Paginate
                        activePage={data?.pager?.page <= data?.pager?.total_pages ? data.pager?.page : 1}
                        itemsCountPerPage={data?.pager.per_page}
                        totalItemsCount={data?.pager.total_rows || 0}
                        pageRangeDisplayed={5}
                        tabIndex={0}
                        onChange={setPage}
                        innerClass={`${pagination}`}              // Class name of <ul> tag
                        // activeClass={}                         // Class name of active <li> tag
                        activeLinkClass={`${activeLink}`}          // Class name of active <a> tag
                        itemClass={`${item}`}                     // Default class of the <li> tag
                        // itemClassFirst={}	                  // Class of the first <li> tag
                        // itemClassPrev={}	                      // Class of the previous <li> tag
                        // itemClassNext={}	                      // Class of the next <li> tag
                        // itemClassLast={}	                      // Class of the last <li> tag
                        // disabledClass={}
                        linkClass={`${link}`}                     // Default class of the <a> tag
                        linkClassFirst={`${first}`}               // Class of the first <a> tag
                        // linkClassPrev={}                       // Class of the previous <a> tag
                        // linkClassNext={}                       // Class of the next <a> tag
                        // linkClassLast={}                       // Class of the last <a> tag
                        firstPageText={<IconChevronsLeft />}
                        prevPageText={<IconChevronLeft />}
                        lastPageText={<IconChevronsRight />}
                        nextPageText={<IconChevronRight />}
                    />
                )}
                {/* eslint-enable */}
            </div>
            <div className={`${clsx(fixedBar, isShowFilter && fixedBarActive)}`}>
                {!isShowFilter
                    ? <button className={`fs_facet-search--fixedBar-button ${fixedBarBtn}`} onClick={openFilter}>
                        <IconFilters /> Filters</button>
                    : <button
                        className={`fs_facet-search--fixedBar-button fs_facet-search--fixedBar-button-active ${fixedBarBtn}`}
                        onClick={closeFilter}>{data?.pager?.result_text}</button>
                }
            </div>
        </>
    );
}

export default Content;
